export const BookingFlowStepsArr = [
  { label: "HIDESUBSERVICE", value: "HIDESUBSERVICE" },
  { label: "HIDEMEMBER", value: "HIDEMEMBER" },
  { label: "HIDETIMESLOT", value: "HIDETIMESLOT" },
  { label: "HIDECENTER", value: "HIDECENTER" },
  { label: "HIDEPINCODEPOPUP", value: "HIDEPINCODEPOPUP" },
  { label: "POPUPBOOKINGJOURNEY", value: "POPUPBOOKINGJOURNEY" },
];
export const ServiceFlowStep = [
  { label: "POPUPBOOKINGJOURNEY", value: "POPUPBOOKINGJOURNEY" },
];

export const intitalValue = {
      serviceName: "",
      serviceFontName: "",
      serviceBoxColorCode: "",
      myPlanPageServiceFontSize: "",
      serviceSubTextSize: "",
      serviceSubTextFont: "",
      subServiceText: "",
      serviceBtnColor: "",
      serviceBtnText: "",
      providerId: "",
      homePageServiceFontSize: "",
      boxFooterColorCode: "",
      boxColorCode_1: "",
      aboutImage: "",
      serviceHeaderImage: "",
      serviceIcon: "",
      servicePoweredBylogo: "",
      icon: "",
      bookingFlowSteps:"",
      iconSize: "",
      serviceFlowType: "",
      brandLogoSize: "",
      serviceLongDesc:"",
      sKUmessage_1: "",
      iconPath_1: "",
      sKUmessage_2: "",
      iconPath_2: "",
      sKUmessage_3: "",
      iconPath_3: "",
      sKUmessage_4: "",
      iconPath_4: "",
      sKUmessage_5: "",
      iconPath_5: "",
      
}
